module.exports = __webpack_public_path__ + "img/notice.bc3e83bf.png";